//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ImagePreview, List, Rate } from "vant";
export default {
  data() {
    return {};
  },
  props: ["rateItemList"],

  components: {
    // [ImagePreview.Component.name]: ImagePreview.Component,
    [Rate.name]: Rate
  },

  computed: {},

  created() {},

  mounted() {},

  methods: {
    previewImg(item) {
      console.log(item.imgsList)
      let list = [];
      for (let i = 0; i < item.imgsList.length; i++) {
        let str = "https://img.reflower.com.cn/" + item.imgsList[i];
        list.push(str);
      }
      ImagePreview(list)
    }
  },
  filters: {
    //时间戳转日期格式
    gmtToStr(time) {
      const date = new Date(time);
      let minutes;
      let hours;
      let month;
      let second;
      let relDate;
      if (date.getSeconds() < 10) {
        second = "0" + date.getSeconds();
      } else {
        second = date.getSeconds();
      }
      if (date.getMinutes() < 10) {
        minutes = "0" + date.getMinutes();
      } else {
        minutes = date.getMinutes();
      }
      if (date.getHours() < 10) {
        hours = "0" + date.getHours();
      } else {
        hours = date.getHours();
      }
      if (date.getMonth() >= 9) {
        month = date.getMonth() + 1;
      } else {
        month = "0" + (date.getMonth() + 1);
      }
      if (date.getDate() < 10) {
        relDate = "0" + date.getDate();
      } else {
        relDate = date.getDate();
      }
      const Str =
        date.getFullYear() +
        "-" +
        month +
        "-" +
        relDate 
      return Str; // 返回的就是yyyy-MM-dd HH:mm:ss格式，上面time就是你传入的林尼治标准时间
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/goodsDetailRateItem.vue